<template>
  <!--div v-if="isSplit" style="width:100%;height:calc(100vh);background-size: cover;background-image: url('https://www.dtouch.es/assets/split/tagoro-mobile.jpg');"-->
  <div v-if="isSplit" style="width:100%;height:calc(100vh); ">
    <table v-if="!isMobile" cellspacing="0" cellspadding="0" border="0" style="width: 100%; height: 100%;">
      <tr >
        <td
          style="height:100%;width:50%;background-size: cover;background-position: center;"
          :style="{ 'background-image': `url('${handleGetSplitImage(domain, 's1', true)}')` }"
          @click="handleGoTo(handleGetSplitDomain(domain, 's1'))"
        />
        <td
          style="height:100%;width:50%;background-size: cover;background-position: center;"
          :style="{ 'background-image': `url('${handleGetSplitImage(domain, 's2', true)}')` }"
          @click="handleGoTo(handleGetSplitDomain(domain, 's2'))"
        />
      </tr>
    </table>
    <table v-else cellspacing="0" cellspadding="0" border="0" style="width: 100%; height: 100%;">
      <tr >
        <td
          style="height:50%;background-size: cover;"
          :style="{ 'background-image': `url('${handleGetSplitImage(domain, 's1', false)}')` }"
          @click="handleGoTo(handleGetSplitDomain(domain, 's1'))"
        />
      </tr>
      <tr >
        <td
          style="height:50%;background-size: cover;"
          :style="{ 'background-image': `url('${handleGetSplitImage(domain, 's2', false)}')` }"
          @click="handleGoTo(handleGetSplitDomain(domain, 's2'))"
        />
      </tr>
    </table>
  </div>
  <v-content v-else>
    <div id="core-view" style="height: 100%;">
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </div>
    <!-- <div v-if="$route.meta.layout !== 'public'" style="height:70px"/>
    <core-footer v-if="$route.meta.layout !== 'public'" style="position:fixed;background-color:#eee" /> -->
  </v-content>
</template>

<script>
import utils from '@/services/utils.js'
export default {
  metaInfo () {
    return {
      title: window.location.hostname.indexOf('webapp') >= 0 ? 'DTouch Web App' : 'DTouch'
    }
  },
  computed: {
    splitConfig () {
      return [
        /*
        {
          mainDomain: 'demo',
          s1: {
            domain: 'grantagororealadventure',
            image: 'https://www.dtouch.es/assets/split/tagorosp1.jpg',
            imageDesktop: 'https://www.dtouch.es/assets/split/tagorodesktopsp1.jpg',
          },
          s2: {
            domain: 'grantagorocastillo',
            image: 'https://www.dtouch.es/assets/split/tagorosp2.jpg',
            imageDesktop: 'https://www.dtouch.es/assets/split/tagorodesktopsp2.jpg',
          },
        },*/
        /*
        {
          mainDomain: 'grantagoro',
          s1: {
            domain: 'grantagororealadventure',
            image: 'https://www.dtouch.es/assets/split/tagorosp1.jpg',
            imageDesktop: 'https://www.dtouch.es/assets/split/tagorodesktopsp1.jpg',
          },
          s2: {
            domain: 'grantagorocastillo',
            image: 'https://www.dtouch.es/assets/split/tagorosp2.jpg',
            imageDesktop: 'https://www.dtouch.es/assets/split/tagorodesktopsp2.jpg',
          },
        },
        {
          mainDomain: 'grantagoro-general',
          s1: {
            domain: 'grantagororealadventure',
            image: 'https://www.dtouch.es/assets/split/tagorosp1.jpg',
            imageDesktop: 'https://www.dtouch.es/assets/split/tagorodesktopsp1.jpg',
          },
          s2: {
            domain: 'grantagorocastillo',
            image: 'https://www.dtouch.es/assets/split/tagorosp2.jpg',
            imageDesktop: 'https://www.dtouch.es/assets/split/tagorodesktopsp2.jpg',
          },
        },
        */
      ]
    },
    isSplit () {
      const domains = this.splitConfig.map(item => item.mainDomain)
      //if (!this.test) return false
      if (domains.indexOf(this.domain) < 0 || window.location.hash.indexOf('share') >= 0) return false
      /*
      if (domains.indexOf(this.domain) >= 0 && window.location.hash.indexOf('share') < 0 && !this.isMobile) {
        window.location.href = `${this.prepareBaseURL(this.domain)}/#/share/`
        return
      }*/
      return true
    },
    domain () {
      return utils.getDomain()
    },
    isMobile () {
      return utils.isMobile() || this.$route.query.fm === 'true' || this.$route.query.onlyContent
    },
    test () {
      return this.$route.query.test === 'true'
    },
    isForceMobile () {
      return this.$route.query.fm === 'true'
    },
    isDev () {
      return process.env.VUE_APP_ENV === 'development' ? true : false
    },
  },
  mounted () {
  },
  methods: {
    prepareBaseURL (v) {
      return `${this.isDev ? 'http' : 'https'}://${v}.dtouch.${this.isDev ? 'local:8006' : 'es'}`
    },
    handleGetSplitDomain (v, type) {
      const aux = this.splitConfig.filter(x => x.mainDomain === v).map(item => item[type].domain).shift()
      return aux
    },
    handleGetSplitImage (v, type, isDesktop) {
      const aux = this.splitConfig.filter(x => x.mainDomain === v).map(item => isDesktop ? item[type].imageDesktop : item[type].image).shift()
      return aux
    },
    handleGoTo (v) {
      window.location.href = `${this.prepareBaseURL(v)}/#/?back=${this.domain}${this.isForceMobile ? '&fm=true' : ''}`
    },
  },
}
</script>

<style>
#core-view {
  /* padding-bottom: 100px; */
}
</style>
